import * as React from "react";
const Location = (props) => (
  <svg
    width={20}
    height={23}
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 0C12.6522 0 15.1957 1.08142 17.0711 3.00635C18.9464 4.93128 20 7.54206 20 10.2643C20 13.7702 18.1378 16.6396 16.1756 18.6982C15.1952 19.7156 14.1255 20.6379 12.98 21.4536L12.5067 21.7843L12.2844 21.936L11.8656 22.2097L11.4922 22.4435L11.03 22.7195C10.7163 22.9033 10.3613 23 10 23C9.63875 23 9.28374 22.9033 8.97 22.7195L8.50778 22.4435L7.93 22.0786L7.71667 21.936L7.26111 21.6246C6.02537 20.7665 4.87434 19.7863 3.82444 18.6982C1.86222 16.6385 0 13.7702 0 10.2643C0 7.54206 1.05357 4.93128 2.92893 3.00635C4.8043 1.08142 7.34784 0 10 0ZM10 6.84288C9.56226 6.84288 9.12881 6.93138 8.72439 7.10332C8.31997 7.27527 7.95251 7.52729 7.64298 7.845C7.33345 8.16271 7.08792 8.53989 6.9204 8.955C6.75289 9.3701 6.66667 9.81501 6.66667 10.2643C6.66667 10.7136 6.75289 11.1585 6.9204 11.5737C7.08792 11.9888 7.33345 12.3659 7.64298 12.6836C7.95251 13.0014 8.31997 13.2534 8.72439 13.4253C9.12881 13.5973 9.56226 13.6858 10 13.6858C10.8841 13.6858 11.7319 13.3253 12.357 12.6836C12.9821 12.042 13.3333 11.1717 13.3333 10.2643C13.3333 9.3569 12.9821 8.48664 12.357 7.845C11.7319 7.20335 10.8841 6.84288 10 6.84288Z"
      fill="#EEEEEE"
    />
  </svg>
);
export default Location;
